import script from "./AuditLogs.vue?vue&type=script&setup=true&lang=js"
export * from "./AuditLogs.vue?vue&type=script&setup=true&lang=js"

import "./AuditLogs.vue?vue&type=style&index=0&id=f13b2b48&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f13b2b48"]])

export default __exports__